import { useCallback } from 'react';

import ProcessInstance, {
  UpdateFileFieldValueParams,
  UpdateFileFieldValueResult,
} from 'api/endpoints/processInstance';
import useTriggeredFetchAction from 'api/hooks/useTriggeredFetchAction';
import { UPLOAD_FILE_FIELD_NAME } from 'constants/global';

type HandleUpdateClick = (blob: Blob, url: string) => void;

const useUpdateInstanceFile = (): [boolean, HandleUpdateClick] => {
  // region *******************************DATA*********************************
  const {
    isPending: isUpdatingFieldValuePending,
    startAction: startUpdatingFieldValue,
  } = useTriggeredFetchAction<
    [UpdateFileFieldValueParams],
    UpdateFileFieldValueResult
  >(ProcessInstance.updateFileFieldValue);
  // endregion

  // region *****************************CALLBACKS******************************
  const handleUpdateClick: HandleUpdateClick = useCallback(
    (blob, url) => {
      const value = new FormData();

      value.append(UPLOAD_FILE_FIELD_NAME, blob);

      startUpdatingFieldValue({ url, value });
    },
    [startUpdatingFieldValue]
  );
  // endregion

  return [isUpdatingFieldValuePending, handleUpdateClick];
};

export default useUpdateInstanceFile;
